document
  .querySelector(".wishlist-page-widget")
  ?.addEventListener("click", () => {
    startBlinking();
  });
document.addEventListener("click", (event) => {
  const customShareList = document.querySelector("ul.wishlist-share");
  const pagePopup =
    document.querySelector(".wishlist-page") ||
    document.querySelector(".sewp-engine-popup");
  if (
    event.target.matches(".custom-share-wishlist-btn") ||
    event.target.closest(".custom-share-wishlist-btn")
  ) {
    if (!customShareList) return;
    customShareList.classList.add("shown_list");
    document.body.classList.add("overflow-hideee");
    if (!pagePopup.querySelector(".share_popup")) {
      const overlay = document.createElement("span");
      overlay.className = "share_popup";
      pagePopup.appendChild(overlay);
    }
  }
  if (
    event.target.matches(".close_share_btn") ||
    event.target.closest(".close_share_btn")
  ) {
    customShareList?.classList.remove("shown_list");
    document.querySelector(".share_popup")?.remove();
    document.body.classList.remove("overflow-hideee");
  }
  if(event.target.matches(".sewp-close") || 
  event.target.closest(".sewp-close")){
    document.body.classList.remove("overflow-hidden");
  }
});
function startBlinking() {
  const intervalId = setInterval(() => {
    const popup = document.querySelector(".sewp-engine-popup");
    if (popup && !popup.classList.contains("show_whl_popup")) {
      popup.classList.add("show_whl_popup");
      document.body.classList.add("overflow-hidden");
      addCustomOverlay(popup);
      clearInterval(intervalId);
    }
  }, 500);
}
function addCustomOverlay(scope) {
  if (!scope.querySelector(".pop_overlay")) {
    const overlay = document.createElement("div");
    overlay.className = "pop_overlay";
    overlay.addEventListener("click", () => closeWishlist(scope));
    scope.appendChild(overlay);
  }
}
function closeWishlist(scope) {
  scope.classList.remove("show_whl_popup");
  document.body.classList.remove("overflow-hidden");
  scope.querySelector(".pop_overlay")?.remove();
  scope.querySelector(".share_popup")?.remove();
}
//===========================================
document.addEventListener("DOMContentLoaded", function () {
  const wishPopObserver = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.classList.contains("wishlist-popup")) {
  const msgContainer = node.querySelector(".wishlist-p-right h3");

  if (
    msgContainer &&
    msgContainer.textContent.includes("is already sold out")
  ) {
    const msgText = msgContainer.textContent;
    const fullMatch = msgText.match(/'(.+?)\/\s*(.+?)'/);

    if (fullMatch) {
      const variantName = fullMatch[2].trim();
      msgContainer.textContent = `${variantName} is out of stock.`;
    } else {
      const productMatch = msgText.match(/'(.+?)'/);
      const productName = productMatch ? productMatch[1].trim() : "This item";
      msgContainer.textContent = `${productName} is out of stock.`;
    }
  }
}


        //-----------------------------------------------
        document
          .querySelectorAll(".sewp-content input[type=checkbox]")
          .forEach(function (checkbox) {
            checkbox.checked = true;
          });
        //-----------------------------------------------
        const bulk = document.querySelector(".bulk_action");
        const hasItems = document.querySelector(
          ".wh-list-layout.active .wh-list-column"
        );
                if (bulk && hasItems) {
          const existingATCBtn = bulk.querySelector(
            "#move_to_cart_all_custom"
          );
          if (!existingATCBtn) {
            const li = document.createElement("li");
            li.innerHTML = `
              <a href="javascript:void(0)" class="move_to_cart_all_custom" role="button" id="move_to_cart_all_custom">
                ADD ALL TO CART
              </a>
            `;
            bulk.appendChild(li);
          }
        }
        if (bulk && hasItems) {
          const existingShareBtn = bulk.querySelector(
            ".custom-share-wishlist-btn"
          );
          if (!existingShareBtn) {
            const li = document.createElement("li");
            li.innerHTML = `
              <a href="javascript:void(0)" class="custom-share-wishlist-btn" role="button">
                SHARE MY WISHLIST
              </a>
            `;
            bulk.appendChild(li);
          }
        }  


        //---------------------------------------------
        const shareList = document.querySelector("ul.wishlist-share");
        if (shareList) {
          if (!shareList.querySelector(".close_share_btn")) {
            const closeBtn = document.createElement("button");
            closeBtn.className = "close_share_btn";
            closeBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512">
              <path d="M25 512a25 25 0 0 1-17.68-42.68l462-462a25 25 0 0 1 35.36 35.36l-462 462A24.93 24.93 0 0 1 25 512z"/>
              <path d="M487 512a24.93 24.93 0 0 1-17.68-7.32l-462-462a25 25 0 0 1 35.36-35.36l462 462A25 25 0 0 1 487 512z"/>
            </svg>`;
            shareList.appendChild(closeBtn);
          }
        }
        //----------------------------------------------
        const pageCont = document.querySelector(".wishlist-page");
        if (pageCont) {
          document
            .querySelectorAll("#wishlist-page-contain input[type=checkbox]")
            .forEach(function (checkbox) {
              checkbox.checked = true;
          });
        }
      });
    });
  });
  wishPopObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

document.addEventListener("click", function (e) {
  if (
    e.target.matches("#move_to_cart_all") ||
    e.target.closest("#move_to_cart_all")
  ) {
    const pageScope =
      e.target.closest(".wishlist-container") ||
      e.target.closest(".sewp-engine-popupinr");

    if (!pageScope) return;

    e.preventDefault();

    const pickers = pageScope.querySelectorAll(".wishlist-variant-picker");
    const waitForOptions = Array.from(pickers).some(
      (p) => !p.querySelector("option")
    );

    if (waitForOptions) {
      const interval = setInterval(() => {
        const allLoaded = Array.from(pickers).every((p) =>
          p.querySelector("option")
        );
        if (allLoaded) {
          clearInterval(interval);
          filterVariantsForAddToCart(pageScope);
        }
      }, 50);
    } else {
      filterVariantsForAddToCart(pageScope);
    }
  }
});

function filterVariantsForAddToCart(scope) {
  const inStockProducts = [];
  const outOfStockProducts = [];
  scope.querySelectorAll(".wh-list-column").forEach((productEl) => {
    const select = productEl.querySelector(".wishlist-variant-picker");
    const moveBtn = productEl.querySelector(".wishlist-move-cart");
    let isInStock = false;
    let qty = 0;
    if (select) {
      const selectedOption = select.selectedOptions?.[0];
      if (!selectedOption) return;
      qty = parseInt(selectedOption.dataset.inventory_quantity || "0", 10);
    } else {
      const qtyAttr =
        moveBtn?.dataset.quntity ||
        productEl.querySelector(".wishlist_item_checkbox")?.dataset.quntity;
      qty = parseInt(qtyAttr || "0", 10);
    }
    isInStock = qty > 0;
    if (isInStock) {
      inStockProducts.push(moveBtn);
      productEl.classList.add('hidden');
    } else {
      outOfStockProducts.push(productEl);
    }
  });
  if (inStockProducts.length > 0 && outOfStockProducts.length === 0) {
    return;
  }
  if (inStockProducts.length === 0 && outOfStockProducts.length > 0) {
    return;
  }
  inStockProducts.forEach((btn) => {
    if (btn) {
      btn.click();
    }
  });
}

function wishlistNotification(failedMessages) {
  // Remove existing popup if any
  document.querySelector('#wishlist-popup-custom')?.remove();

  const html = `
    <div class="wishlist-popup" id="wishlist-popup-custom" data-position="top-left" style="position: fixed; top: 20px; left: 20px; background: #fff; transform:translateX(0); padding: 20px; border: 1px solid #ccc; z-index: 9999; box-shadow: 0 0 10px rgba(0,0,0,0.15); max-width: 300px;">
      <button class="close-wishlist" style="float: right; background: transparent; border: none; font-size: 12px; text-transform: uppercase; cursor: pointer;">&times;</button>
      <div class="wishlit-popupinr">
        <div class="wishlist-p-right">
        ${failedMessages.length ? `
          <h4 style="margin: 0 0 10px;font-size: 12px; color: #191919; text-transform: uppercase;">Some items couldn't be added to the cart:</h4>
          <ul style="margin: 0; padding-left: 18px; list-style-type: none; padding-left: 0; font-size: 12px; color: #191919; text-transform: uppercase;">
             ${failedMessages.map(msg => `<li>${msg.title}</li>`).join('')}
          </ul>` : ` 
          <h4 style="margin: 0 0 10px;font-size: 12px; color: #191919; text-transform: uppercase;">All items added to cart</h4>
          `}
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', html);

  // Auto-remove after 3 seconds
  setTimeout(() => {
    document.querySelector('#wishlist-popup-custom')?.remove();
  }, 3000);

  // Manual close
  document.querySelector('#wishlist-popup-custom .close-wishlist')?.addEventListener('click', () => {
    document.querySelector('#wishlist-popup-custom')?.remove();
  });
}

document.addEventListener('click', async function (event) {
  const target = event.target.matches('#move_to_cart_all_custom')
    ? event.target
    : event.target.closest('#move_to_cart_all_custom');

  if (!target) return;
  event.preventDefault();

  target.classList.add("loading");

  const failedItems = [];
  const parent = target.closest('.sewp-engine-popup') || target.closest('.wishlist-container');
  const productElements = parent.querySelectorAll('.wishlist-variant-picker option:checked');

  const IDs = [];
  productElements.forEach(el => {
    const inventory = parseInt(el.getAttribute('data-inventory_quantity')) || 0;
    if (inventory > 0) {
      IDs.push(el.value);
    } else {
      failedItems.push({
        id: el.value,
        title: el.closest('.wh-pro-meta')?.querySelector('h3 a')?.textContent.trim() || el.textContent.trim() // you can capture product title here if needed
      });
    }
  });

  if (IDs.length) {
    window.AddAlltoCartDrawer(IDs);
  }

  target.classList.remove("loading");
  document.querySelector('#delete_all')?.click();
 
    wishlistNotification(failedItems); 
});


window.AddAlltoCartDrawer = function (IDs) {
  if (!Array.isArray(IDs) || IDs.length === 0) {
    console.warn("No matching variant IDs found.");
    return;
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML || "";
  }

  const sectionsToRender = [
    { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
    { id: "cartIconBubble", section: "cart-icon-bubble", selector: ".cart-count-section" },
  ];

  const formData = new FormData();
  IDs.forEach((variantId, index) => {
    formData.append(`items[${index}][id]`, variantId);
    formData.append(`items[${index}][quantity]`, 1);
  });

  formData.append(
    "sections",
    sectionsToRender.map((s) => s.section)
  );
  formData.append("sections_url", window.location.pathname);

  const config = {
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    body: formData,
  };

  document.querySelector("cart-drawer")?.classList.add("loading");

  fetch(`/cart/add.js`, config)
    .then((res) => res.json())
    .then((response) => {
      if (response.status) {
        console.error("Add to cart error:", response.description);
        return;
      }

      document.querySelector("cart-drawer")?.classList.remove("is-empty");
      sectionsToRender.forEach((section) => {
        const element = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (element && response.sections?.[section.section]) {
          element.innerHTML = getSectionInnerHTML(
            response.sections[section.section],
            section.selector
          );
        }
      });
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    })
    .finally(() => {
      document.querySelector("cart-drawer")?.classList.remove("loading");
    });
};